import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1653657120248'
        className='icon'
        viewBox='0 0 1054 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='10521'
    >
        <path
            d='M183.330352 579.940058a397.774272 216.457357 0 1 0 795.548545 0 397.774272 216.457357 0 1 0-795.548545 0Z'
            p-id='10522'
            fill='currentColor'
        ></path>
        <path
            d='M303.271342 583.84767a88.551481 53.881075 90 1 0 107.76215 0 88.551481 53.881075 90 1 0-107.76215 0Z'
            p-id='10523'
            fill='currentColor'
        ></path>
        <path
            d='M523.944991 579.940058a88.551481 53.881075 90 1 0 107.76215 0 88.551481 53.881075 90 1 0-107.76215 0Z'
            p-id='10524'
            fill='currentColor'
        ></path>
        <path
            d='M744.618639 583.688652a88.551481 53.881075 90 1 0 107.762151 0 88.551481 53.881075 90 1 0-107.762151 0Z'
            p-id='10525'
            fill='currentColor'
        ></path>
        <path
            d='M59.640768 433.761246h135.636914v288.60903H59.640768zM411.031154 269.777195h333.587485v112.850698H411.031154z'
            p-id='10526'
            fill='currentColor'
        ></path>
        <path d='M560.020827 155.457928h36.545872v148.989673H560.020827z' p-id='10527' fill='currentColor'></path>
        <path d='M560.020827 155.457928h95.578634v28.11095H560.020827z' p-id='10528' fill='currentColor'></path>
    </svg>
)

export const ROVIcon = props => <Icon component={SVG} {...props} />
